import { render, staticRenderFns } from "./ActiveTenderPlug.vue?vue&type=template&id=54e2e3e9&"
import script from "./ActiveTenderPlug.vue?vue&type=script&lang=js&"
export * from "./ActiveTenderPlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports